export default __webpack_public_path__ + "static/media/RTR 160 4V_3.14c572bf.webp";